export default "__VITE_ASSET__CFNZn2Wy__"